import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: spacing(3, 15.75, 0, 15.75),
    [breakpoints.down('sm')]: {
      margin: spacing(1),
    },
  },
  containerX: {
    [breakpoints.up('sm')]: {
      marginTop: '30px',
    },
  },
  subContainer: {
    display: 'grid',
    justifyContent: 'space-evenly',
    [breakpoints.down('sm')]: {
      margin: spacing(1),
      flexDirection: 'column',
    },
  },
  confirmButton: {
    marginTop: spacing(4),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0),
    },
  },
  backButton: {
    marginTop: spacing(4),
    // backgroundColor: palette.green.dark,
    color: palette.green.main,
    border: `2px solid ${palette.green.dark}`,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.white.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(0),
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '@media (max-width:375px)': {
      flexDirection: 'column-reverse',
    },
    '@media (max-width:320px)': {
      flexDirection: 'column-reverse',
    },
    [breakpoints.up('lg')]: {
      justifyContent: 'end',
    },
  },
  empty: {
    display: 'flex',
    width: '600px',
    [breakpoints.down('md')]: {
      width: '0px',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: spacing(2, 1, 2, 15),
    background: palette.white.main,
    width: '600px',
    flexWrap: 'wrap',
    '& label': {
      userSelect: 'none',
    },
    '& button': {
      marginBottom: spacing(1),
      [breakpoints.up('md')]: {
        margin: spacing(0),
      },
    },
    [breakpoints.down('lg')]: {
      padding: spacing(0),
      width: '100%',
    },
    [breakpoints.up('md')]: {
      padding: '16px 10%',
      gap: '16px',
    },
    [breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      flexDirection: 'column-reverse',
      marginRight: spacing(0),
      marginTop: spacing(2),
    },
    '@media (max-width:375px)': {
      flexDirection: 'column-reverse',
    },
    '@media (max-width:320px)': {
      flexDirection: 'column-reverse',
    },
  },
  logoImage: {
    width: '1000px',
    height: '100%',
    [breakpoints.down('sm')]: {
      left: spacing(9),
      width: 'auto',
      height: '100px',
      top: spacing(2),
      // padding: spacing(1),
      marginTop: spacing(2),
      display: 'flex',
    },
  },
  logoContainer: {
    width: '100%',
    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },

    [breakpoints.between('sm', 'md')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: 'auto 100px' /* Adjust the height of the second row */,
    },
    [breakpoints.up('md')]: {
      display: 'grid',

      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: 'auto 100px' /* Adjust the height of the second row */,
    },
  },
  gridItem: {
    ':nth-child(2)': {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    ':nth-child(3)': {
      gridRow: 2 /* Place items 3 and 4 in the second row */,
      height: '100px' /* Set a lower height for items 3 and 4 */,
    },
    ':nth-child(4)': {
      gridRow: 2 /* Place items 3 and 4 in the second row */,
      height: '100px' /* Set a lower height for items 3 and 4 */,
    },
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(6),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  subTitle: {
    margin: spacing(1, 1, 2, 1),
    fontSize: spacing(1.75),
    fontWeight: spacing(87.5),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    // width: '800px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(2),
    },
    '@media (max-width:375px)': {
      fontSize: spacing(1.375),
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.375),
    },
    [breakpoints.up('lg')]: {
      margin: spacing(1, 0, 2, 0),
    },
    [breakpoints.up('xl')]: {
      margin: spacing(1, 1, 2, 1),
    },
  },

  subTitle1: {
    margin: spacing(1),
    marginBottom: '-2rem',
    fontSize: spacing(1.75),
    fontWeight: spacing(87.5),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(2),
      marginBottom: '-0.5rem',
    },
    '@media (max-width:375px)': {
      fontSize: spacing(1.375),
      marginBottom: '-0.5rem',
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.375),
      marginBottom: '-0.5rem',
    },
  },

  subTitle2: {
    marginTop: spacing(12),
    // fontSize: spacing(1.75),
    // fontWeight: spacing(87.5),
    // fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(2),
      marginBottom: '-0.5rem',
    },
    '@media (max-width:375px)': {
      fontSize: spacing(1.375),
      marginBottom: '-0.5rem',
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.375),
      marginBottom: '-0.5rem',
    },
  },

  fullNameTypography: {
    margin: spacing(1),
    fontSize: spacing(1.75),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    // width: '800px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(2),
      fontWeight: spacing(75),
    },
  },
  talkstageclip: {
    color: palette.green.dark,
    fontWeight: spacing(100),
    margin: spacing(1),
    fontSize: spacing(1.75),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    // width: '800px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(2),
      fontWeight: spacing(75),
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  videoContainer: {
    width: '600px',
    // marginBottom: '5rem',
    [breakpoints.down('sm')]: {
      width: '380px',
    },
    [breakpoints.up('md')]: {
      width: '540px',
    },
    [breakpoints.up('lg')]: {
      width: '560px',
    },
    [breakpoints.up('xl')]: {
      width: '680px',
      margin: 'auto',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '330px',
    },
  },
  playerContainer: {
    position: 'relative',
    marginLeft: '2rem',
    width: '600px', // Adjust width as needed
    border: '2px solid black',
    borderRadius: '8px',
    // padding: spacing(2.5),
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.up('md')]: {
      width: '540px',
      margin: 'auto',
    },
    [breakpoints.up('lg')]: {
      width: '560px',
    },
    [breakpoints.up('xl')]: {
      width: '680px',
      margin: 'auto',
    },
    [breakpoints.down('sm')]: {
      width: '387px',
      justifyContent: 'center',
      marginLeft: '0rem',
    },
    '@media (max-width:375px)': {
      width: '338px',
      marginLeft: '0rem',
      justifyContent: 'center',
    },
    '@media (max-width:320px)': {
      width: '310px',
      marginLeft: '0rem',
      justifyContent: 'center',
    },
  },
  borderLine: {
    // border: `1px solid ${palette.green.dark}`,
    // marginLeft: '10px',
    [breakpoints.down('sm')]: {
      marginTop: spacing(1),
      width: '100%',
      border: `1px solid ${palette.green.dark}`,
    },
  },
  borderLineFinal: {
    border: `2px solid ${palette.green.dark}`,
    width: '100%',
    [breakpoints.down('sm')]: {
      marginTop: spacing(1),
      width: '100%',
      border: `1px solid ${palette.green.dark}`,
    },
  },
  playButton: {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: '#fff',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '30px',
    zIndex: 1,
    // '&:hover': {
    //   background: fade(palette.green.main, 0.5),
    // },
    '@media (max-width: 600px)': {
      top: '40%', // Adjust for smaller screens
      width: '50px',
      height: '50px',
      fontSize: '24px',
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    marginTop: '20px',
    // '&$disabled': {
    //   backgroundColor: fade(palette.green.main, 0.2),
    // },
  },
  playButtonMobile: {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: '#fff',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '30px',
    zIndex: 1,
    // '&:hover': {
    //   background: fade(palette.green.main, 0.5),
    // },
    marginTop: '20px',
    // '&$disabled': {
    //   backgroundColor: fade(palette.green.main, 0.2),
    // },
  },
  inOutTimes: {
    display: 'flex',
    marginTop: spacing(2),
  },
  inTimeText: {
    marginLeft: '10px',
    marginRight: '20px',
  },
  outTimeText: {
    marginRight: '10px',
  },
  videoContentContainer: {
    // marginRight: '-10rem',
    [breakpoints.down('sm')]: {
      marginRight: '0px',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      display: 'flex',
    },
    '@media (max-width:375px)': {
      fontSize: spacing(1.5),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: '0px',
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.5),
      marginRight: '0px',
      alignItems: 'center',
    },

    // border: '2px solid black',
    // padding: '20px',
  },
  audioPlayButton: {
    marginTop: spacing(4),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    position: 'absolute',
    top: '50%',
    left: '44%',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0),
    },
  },
  textLabel: {
    color: '#18a957',
    fontWeight: spacing(75),
    fontFamily: 'Open Sans',
    lineHeight: '21.79px',
    fontSize: spacing(2),
    '& div > .MuiInputLabel-root': {
      width: spacing(43.75),
    },
  },
  textFieldRoot: {
    [breakpoints.down('sm')]: {
      '& .MuiInputLabel-root': {
        width: spacing(43.75),
      },
    },
  },
  audioContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',

    [breakpoints.up('md')]: {
      padding: '0 10%',
    },
  },

  nameContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  nameContainerMain: {
    border: `2px solid`,
    borderRadius: '8px',
    padding: spacing(5),
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.only('lg')]: {
      padding: spacing(2.5),
    },
    [breakpoints.down('sm')]: {
      marginTop: spacing(3),
      marginBottom: '0rem',
      padding: spacing(5, 2, 5, 2),
    },
  },
  audioContainerSub: {
    border: `2px solid`,
    borderRadius: '8px',
    padding: spacing(2, 2.5),
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    // marginTop: spacing(1),
    [breakpoints.down('md')]: {
      padding: spacing(2.5),
    },
  },
  ledgerText: {
    color: palette.green.dark,
    fontWeight: spacing(100),
    fontSize: spacing(1.75),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    // width: '800px',
    position: 'absolute',
    top: -10,
    // fontSize: '16px',
    padding: '0 8px',
    backgroundColor: 'white',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(0),
      fontWeight: spacing(75),
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  audioPlayer: {
    '& .input': {
      pointerEvents: 'none',
      cursor: 'not-allowed',
    },
  },
  nameContainerMobile: {
    display: 'flex',
    gap: '16px',
    width: '100%',
    // [breakpoints.down('sm')]: {
    //   flexDirection: 'column',
    // },
  },
}));
